
<template>
  <!-- <MainLayout> -->
    <router-view></router-view>
  <!-- </MainLayout> -->
</template>

<script>
// import MainLayout from './layouts/MainLayout.vue';



export default {
  name: 'App',
  components: {
    // MainLayout
    
  }
}
</script>

<style>
@font-face {
  font-family: 'Nunito';
  src: url('@/assets/fonts/Nunito/Nunito-VariableFont_wght.ttf') format('truetype');
  font-weight: 200 1000;
  font-display: swap;
}

#app {
  font-family: 'Nunito';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}


</style>
